import { useState } from 'react';
import { api } from '@/services/api';
import { useUIStore } from '@/stores/uiStore';

export function ReportHazard() {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  // Hide on mobile when a panel/bottom-sheet is open, matching the other
  // floating controls so the sheet isn't crowded.
  const anyPanelOpen = useUIStore((s) => Object.entries(s.panels).some(([k, v]) => v && k !== 'searchPanel'));

  const report = async (type: string) => {
    setLoading(true);
    // Get current location (mock for now, ideally pass from map context)
    navigator.geolocation.getCurrentPosition(async (pos) => {
      try {
        await api.post('/traffic/incidents', {
          type,
          description: `User reported ${type}`,
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          user_id: 'user-123', // Mock user ID for gamification
        });
        
        // Show gamification feedback
        const notification = document.createElement('div');
        notification.className = 'fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-yellow-400 text-yellow-900 font-bold px-6 py-3 rounded-full shadow-xl z-50 animate-bounce';
        notification.textContent = '+10 Karma! 🌟';
        document.body.appendChild(notification);
        setTimeout(() => notification.remove(), 2000);

        setIsOpen(false);
      } catch (e) {
        alert('Failed to report');
      } finally {
        setLoading(false);
      }
    });
  };

  return (
    <div className={`absolute bottom-24 right-4 z-controls ${anyPanelOpen ? 'max-md:hidden' : ''}`}>
      {isOpen ? (
        <div className="bg-white p-4 rounded-lg shadow-lg flex flex-col gap-2">
          <h3 className="font-bold text-gray-700">Report Hazard</h3>
          <button 
            disabled={loading}
            onClick={() => report('accident')}
            className="p-2 bg-red-100 text-red-700 rounded hover:bg-red-200"
          >
            🚗 Accident
          </button>
          <button 
            disabled={loading}
            onClick={() => report('police')}
            className="p-2 bg-blue-100 text-blue-700 rounded hover:bg-blue-200"
          >
            👮 Police
          </button>
          <button 
            disabled={loading}
            onClick={() => report('hazard')}
            className="p-2 bg-yellow-100 text-yellow-700 rounded hover:bg-yellow-200"
          >
            ⚠️ Hazard
          </button>
          <button onClick={() => setIsOpen(false)} className="text-gray-500 text-sm mt-2">Cancel</button>
        </div>
      ) : (
        <button
          onClick={() => setIsOpen(true)}
          className="bg-orange-500 hover:bg-orange-600 text-white p-3 rounded-full shadow-lg flex items-center justify-center w-12 h-12"
          title="Report Hazard"
        >
          <span className="text-2xl">+</span>
        </button>
      )}
    </div>
  );
}
